export default __webpack_public_path__ + "static/media/3.580477b5.png";